import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Utils from "../Utils";

const accountLabels = {
  photographer: "Photographer",
  "hotel-owner": "Owner Representative",
};

const ForgotPassword = () => {
  const { userType } = useParams();
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [processing, setProcessing] = useState(false);

  const accountLabel = useMemo(
    () => accountLabels[userType] || "Account",
    [userType],
  );

  useEffect(() => {
    document.body.className =
      "bg-gray-100 flex items-center justify-center min-h-screen px-4 py-6";
    return () => {
      document.body.className = "bg-gray-50";
    };
  }, []);

  const submitForm = (event) => {
    event.preventDefault();
    setProcessing(true);
    setError(false);
    setSuccess(false);

    axios
      .post(
        Utils.apiUrl("frontend/auth/forgot-password"),
        { email, user_type: userType },
        Utils.apiHeaders(),
      )
      .then((res) => {
        if (res.data.success) {
          setSuccess(res.data.message);
          setEmail("");
        } else {
          throw res.data;
        }
      })
      .catch((err) => {
        console.log("Forgot password error:", err);

        setError(
          err?.response?.data?.message ||
            err?.message ||
            "Failed to send reset password link.",
        );
      })
      .finally(() => setProcessing(false));
  };

  return (
    <div className="w-full max-w-xl rounded-lg bg-white p-8 shadow-md loginWrap">
      <div className="flex justify-center pb-8">
        <img
          src={`${process.env.PUBLIC_URL}/images/logo.png`}
          alt="Marriott Bonvoy"
          className="logo max-w-full"
        />
      </div>
      <h2 className="mb-2 text-center text-2xl font-bold">Forgot Password</h2>
      <p className="mb-6 text-center text-sm text-gray-600">
        {accountLabel} account
      </p>

      {success && (
        <div className="mb-4 rounded bg-green-100 p-3 text-green-700">
          {success}
        </div>
      )}
      {error && (
        <div className="mb-4 rounded bg-red-100 p-3 text-red-700">{error}</div>
      )}

      <form onSubmit={submitForm} className="space-y-5">
        <div>
          <label className="mb-2 block text-sm font-bold text-gray-700">
            Email Address
          </label>
          <input
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
            className="w-full rounded border px-3 py-2 text-gray-700 shadow focus:outline-none focus:shadow-outline"
            placeholder="Enter your email address"
          />
        </div>

        <div className="flex items-center justify-between gap-4">
          <a
            href={process.env.PUBLIC_URL + "/"}
            className="text-sm text-blue-600 hover:text-blue-800"
          >
            Back to Login
          </a>
          <button
            type="submit"
            disabled={processing}
            className="btn rounded px-5 py-2 font-bold text-white disabled:opacity-60"
          >
            {processing ? "Sending..." : "Send Reset Link"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
